import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  page: 1,
  limit: 10,
  totalPage: 2,
  pageInfo: {},

  list: [],
  detail: {}
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
